export const ROLES_AND_PERMISSIONS = [
  // OWNER
  {
    id: 'Owner',
    role: 'Owner',
    permissions: [
      { id: 'add-project-completion-message', role: 'Add Project Completion and welcome message' },
      { id: 'add-project-informed-consent', role: 'Add Project Consent to Participate' },
      { id: 'create-project', role: 'Create projects - conditional CSI license' }
    ]
  },
  // ADMINISTRATOR
  {
    id: 'Administrator',
    role: 'Administrator',
    permissions: [
      { id: 'deactivate-participants', role: 'Deactivate participants' },
      { id: 'delete-analysis-scenarios', role: 'Delete analysis scenarios' },
      { id: 'edit-general-project-settings', role: 'Edit general project settings and all project general content' },
      { id: 'reset-participant-passwords', role: 'Reset participant passwords' },
      { id: 'role-management', role: 'Role Management' }
    ]
  },
  // PRODUCER
  {
    id: 'Producer',
    role: 'Producer',
    permissions: [
      { id: 'add-edit-analysis-scenarios', role: 'Add, edit analysis' },
      { id: 'approve-reject-participants-data', role: 'Approve and reject participant’s data' },
      { id: 'create-edit-reports', role: 'Create and edit reports' },
      { id: 'delete-activities', role: 'Delete activities: statements, rating questions & participant questions' },
      { id: 'edit-activities-instructions', role: 'Edit activity instructions' },
      { id: 'export-entire-project', role: 'Export entire project' },
      { id: 'manage-activities', role: 'Manage activity settings: Includes identification and open/close status' }
    ]
  },
  // DESIGNER
  {
    id: 'Designer',
    role: 'Designer',
    permissions: [
      { id: 'add-edit-activities', role: 'Add, edit statements, rating questions and participant questions' },
      { id: 'add-participants-and-assign-activities', role: 'Add participants, assign activities' },
      { id: 'add-project-focus-prompt', role: 'Add, edit the Project Consent to Participate and Focus Prompt' }
    ]
  },
  // COLLABORATOR
  {
    id: 'Collaborator',
    role: 'Collaborator',
    permissions: [
      { id: 'enter-data-offline', role: 'Enter data for offline collected activities: participant questions, sorting and rating' }
    ]
  },
  // READER
  {
    id: 'Reader',
    role: 'Reader',
    permissions: [
      { id: 'view-all-analysis-and-report-screens', role: 'View all analysis & report screens' },
      { id: 'view-project-activities-and-participant', role: 'Can view project activities and participants' }
    ]
  },
  // SPECIAL PERMISSIONS
  {
    id: 'Special permissions',
    role: 'Special permissions',
    permissions: [
      { id: 'delete-participant-project', role: 'Delete participants' },
      { id: 'flip-scale', role: 'Flip rating scale' },
      { id: 'relocate-points', role: 'Relocate map points' }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/app/shared/constants/roles-and-permissions.ts